import React from 'react';
import styled from 'styled-components';
import { DeviceIcon, DynamicLink } from 'packages/smart-home-support/components';
import { Device } from '../../models';
import { getUrl } from '../../utils';
import { LinkId } from 'packages/smart-home-support/constants';

const s = {
  Container: styled(DynamicLink)<{ hasDevice: boolean }>`
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: ${(props) => (props.hasDevice ? 'space-between' : 'center')};
    color: inherit;
    text-decoration: none;
    padding: 18px;
    box-sizing: border-box;
    border: ${(props) => (props.hasDevice ? '1px solid #D8DADA' : '1px dashed #747676')};
    border-radius: 6px;
    width 150px;
    height: 136px;
    background-color: ${(props) => (props.hasDevice ? 'transparent' : '#f6f6f6')}
    @media (max-width: 370px) {
      width 125px;
    }
  `,
  IconWrapper: styled.span`
    width: 75px;
    height: 54px;
  `,
  DeviceName: styled.h3`
    margin: 0;
    font-size: 16px;
    text-align: center;
    @media (max-width: 370px) {
      font-size: 14px;
    }
  `,
  PlusIcon: styled.div`
    display: flex;
    position: relative;
    width: 30px;
    height: 30px;
    justify-content: center;
    border-radius: 999px;
    background: #000;
    margin-bottom: 15px;
    :after {
      content: '';
      display: block;
      position: absolute;
      width: 3px;
      height: 15px;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      margin: auto;
      background: #f6f6f6;
    }
    :before {
      content: '';
      display: block;
      position: absolute;
      width: 15px;
      height: 3px;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      margin: auto;
      background: #f6f6f6;
    }
  `,
};

const Device: React.FC<{ device?: Device }> = ({ device }) => {
  return (
    <s.Container
      id={device ? LinkId.DashboardDevicesViewDevice : LinkId.DashboardDevicesAddDevice}
      className={device ? LinkId.DashboardDevicesViewDevice : LinkId.DashboardDevicesAddDevice}
      to={device ? getUrl(`view-device?deviceId=${device.id}`) : getUrl('add-device')}
      hasDevice={Boolean(device)}
    >
      {device ? (
        <>
          <s.IconWrapper>
            <DeviceIcon deviceType={device.type} isAccented />
          </s.IconWrapper>
          <s.DeviceName>{device.label}</s.DeviceName>
        </>
      ) : (
        <>
          <s.PlusIcon />
          <s.DeviceName>Add Device</s.DeviceName>
        </>
      )}
    </s.Container>
  );
};

export default Device;



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/profile/tabs/DevicesTab/Device.tsx